/// <amd-module name="TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionSaga" />
import { effects, SagaIterator } from "redux-saga";
import { ActionsOfType } from "redux/Utils/ActionHelper";
import { Area, Feature, TelemetryProperties } from "TFS/Admin/Common/Constants/TelemetryConstants";
import { getOrganizationClient, IOrganizationRestClient } from "TFS/Admin/Common/RestClient/Organization";
import { AdminTelemetry } from "TFS/Admin/Common/Util/Telemetry/AdminTelemetry";
import { gitHubInvitationProperty } from "TFS/Admin/Views/GitHubConnection/Constants";
import { GitHubConnectionActions, GitHubConnectionActionTypes } from "TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionActions";
import * as GitHubConnectionDataSource from "TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionDataSource";
import { GitHubConnectionData } from "TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionDataSource";
import { IVssPageContext } from "VSS/Platform/Context";
import { JsonPatchOperation, Operation } from "VSS/Platform/Contracts/WebApi";

export function* GitHubConnectionSaga(): SagaIterator {
    yield effects.takeEvery(GitHubConnectionActionTypes.InitView, initializeGitHubConnection);
    yield effects.takeEvery(GitHubConnectionActionTypes.MarkCollection, markCollection);
    yield effects.takeEvery(GitHubConnectionActionTypes.logTelemetry, logTelemetry);
}

export function* initializeGitHubConnection(): SagaIterator {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    var telemetryLogger: AdminTelemetry = new AdminTelemetry(pageContext);
    const data: GitHubConnectionData = (yield effects.call(GitHubConnectionDataSource.getGitHubConnectionData, pageContext, {})) as any;
    // TODO: load user invite property to appropriately show if is toggled on or off.
    if (data) {
        yield effects.put(GitHubConnectionActions.initialLoadSucceeded(data));
    } else {
        yield effects.put(GitHubConnectionActions.logTelemetry("Initial GitHub DataProvider load failed"));
        // TODO: Add error-handling once we have a spec for error handling messaging, etc.
    }
}

export function* markCollection(action: ActionsOfType<GitHubConnectionActions, GitHubConnectionActionTypes.MarkCollection>): SagaIterator {
    const { toggleSetting, collectionId } = action.payload;
    if (!collectionId || collectionId.length == 0) {
        yield effects.put(GitHubConnectionActions.logTelemetry("GitHub MarkCollection failed- no valid collectionId"));
    }

    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const organizationRestClient: IOrganizationRestClient = getOrganizationClient(pageContext);
    let operations: JsonPatchOperation[] = [];
    operations.push({
        from: "",
        op: Operation.Replace,
        path: gitHubInvitationProperty,
        value: toggleSetting.toString()
    } as JsonPatchOperation);
    organizationRestClient.updateCollectionProperties(collectionId, operations);
    yield effects.put(GitHubConnectionActions.toggleWasToggled(toggleSetting));

    // TODO: add error handling
}

export function* logTelemetry(actionName: ActionsOfType<GitHubConnectionActions, GitHubConnectionActionTypes.logTelemetry>) {
    const { action, properties } = actionName.payload;
    // @ts-expect-error TypeScript 4.2 upgrade
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    var telemetryLogger: AdminTelemetry = new AdminTelemetry(pageContext);
    if (properties) {
        properties[TelemetryProperties.Action] = action;
        properties[TelemetryProperties.SubFeature] = Feature.GitHubConnection;
        properties[TelemetryProperties.PageUrl] = window.location.pathname.toLowerCase();
        properties[TelemetryProperties.ErrorMessage] = "no error message";
    }

    yield effects.call(telemetryLogger.sendComplexTelemetry, Area.Admin, Feature.GitHubConnection, properties);
}
